module.exports = __webpack_public_path__ + "img/NoImage.7b6bf728.png";